import HelpTitle from 'components/common/HelpTitle';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ExportMenu() {
  console.log('ExportMenu');
  const navigate = useNavigate();

  function clicked(target) {
    //console.log('SB clicked', target);
    navigate(target);
  }

  return (
    <div className='pt-8 h-full text-center font-bold text-2xl bg-blue-200 '>
      <HelpTitle title="Export Data" helpSubject="ExportData" />
      <div className={'mt-10 ml-2'} >
        <MenuItem title={'Export Printable Medication List'} target={'/exportMedsPrint'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Export History Data (CSV)'} target={'/exportHistory'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Export All Data (JSON)'} target={'/exportAll'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Export User Data (JSON)'} target={'/exportUser'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Archive History Data'} target={'/archive'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Import All Data (JSON)'} target={'/importAll'} doClick={(t)=>clicked(t)} />
        <MenuItem title={'Save Data Test'} target={'/savedatatest'} doClick={(t)=>clicked(t)} />
      </div>
  </div>
  );

  function MenuItem({title,target,doClick}) {

    function clicked() {
      //console.log('MI clicked', target);
      doClick(target);
    }

    return (
        <div 
        onClick={clicked}
        className={'text-base small:text-xl py-2 small:py-4 font-semibold hover:font-bold hover:cursor-pointer '} 
        >
            {title}
        </div>
    );
  }
}
